import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import useAuthStore from "../../../store/Auth";
import { useDeleteDepartmentById } from "../../../hooks/common/mutation";
import { useTranslation } from "react-i18next";
import { DELETE_STATUSES } from "../../../constants/common";

interface DeleteDepartmentModalProps {
  departmentId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteDepartmentModal = ({
  departmentId,
  isOpen,
  onOpenChange,
}: DeleteDepartmentModalProps) => {
  const {
    mutateAsync: DeleteDepartmentById,
    isPending: isDeleteDepartmentByIdLoading,
  } = useDeleteDepartmentById();

  const { t } = useTranslation();

  const user = useAuthStore((state) => state.user);

  const handleDeleteDepartment = useCallback(async () => {
    try {
      if (user?.user_id) {
        const body = {
          encryptedId: departmentId.toString(),
          encryptedUserId: user?.user_id.toString(),
        };
        await DeleteDepartmentById(body);
        toast.success(t("departmentDeleted"));
      }
    } catch (error: any) {
      if (error.result.deleteStatus === DELETE_STATUSES.USED_IN_APPOINTMENT) {
        toast.error(t("departmentNotDeletedUsedByAppointment"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [DeleteDepartmentById, t, departmentId, onOpenChange, user?.user_id]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteDepartment")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteDepartment}
            isLoading={isDeleteDepartmentByIdLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteDepartmentModal);
